module.exports = __webpack_public_path__ + "img/image.4114e130.svg";